module.exports = __webpack_public_path__ + "static/media/quiz-icon.300bcb1c.svg";